import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import pt from "./locales/pt.json";
import am from "./locales/am.json";
import az from "./locales/az.json";
import kz from "./locales/kz.json";
import tr from "./locales/tr.json";
import be from "./locales/be.json";
import LanguageDetector from "i18next-browser-languagedetector";

// По умолчанию английский язык
let lang = "en";

// Логирование изменения языка
i18n.on('languageChanged', (lng) => {
  console.log(`🌐 Язык изменен на: ${lng}`);
});

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      pt: { translation: pt },
      am: { translation: am },
      az: { translation: az },
      kz: { translation: kz },
      tr: { translation: tr },
      be: { translation: be }
    },
    lng: lang, // Язык по умолчанию
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
